async function getCartItems() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    return cart?.items?.length ? cart.items : null;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return null;
  }
}

async function getItemCount() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    return cart?.items?.length ? cart.item_count : 0;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return 0;
  }
}

function updateCartCount(count) {
  const cartLink = document.getElementById("cart-icon-bubble");
  let bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble");
  if (!cartLink) {
    toggleCartLoader("hide");
    return;
  }
  if (count > 0) {
    cartLink.classList.remove("fp-cart-empty__icon");
    if (!bubble) {
      bubble = document.createElement("div");
      bubble.className = "cart-count-bubble body-sm fp-font-weight--medium fp-cart-count__single-digit";
      const itemCount = document.createElement("span");
      itemCount.setAttribute("aria-hidden", "true");

      bubble.appendChild(itemCount);
      cartLink.appendChild(bubble);
    }
    bubble.querySelector('span[aria-hidden="true"]').textContent = String(count);
  } else {
    if (bubble) {
      bubble.remove();
    }
    cartLink.classList.add("fp-cart-empty__icon");
  }
  if (window.location.pathname === "/cart") {
    window.location.reload();
  }
  toggleCartLoader("hide");
}

async function addCartItems(items, successCallback, failCallback, shouldUpdateCount = true) {
  toggleCartLoader("show");
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    });
    if ((response?.status && response.status !== 200) || !response.ok) {
      if (failCallback) failCallback();
      throw new Error("Failed to add items to cart");
    } else {
      const data = await response?.json();
      if (successCallback) successCallback(data);
    }

    if (shouldUpdateCount) {
      if (window.location.pathname === "/cart") {
        window.location.reload();
      }
      const cartCount = await getItemCount();
      updateCartCount(cartCount);
      return;
    } else {
      toggleCartLoader("hide");
    }
  } catch (err) {
    console.error(`Error adding to cart:`, err);
    toggleCartLoader("hide");
  }
}

async function updateCartItemQuantity(url, quantity = 0, successCallback, failCallback, shouldUpdateCount = true) {
  toggleCartLoader("show");
  if (!url) {
    toggleCartLoader("hide");
    return;
  }
  const removeUrl = `${url}&quantity=${quantity}`;
  try {
    const data = await fetch(removeUrl);
    if (data.status && data.status !== 200) {
      if (failCallback) failCallback();
      throw new Error(data.description || "Failed to remove items from cart");
    } else {
      if (successCallback) successCallback(data);
    }

    if (shouldUpdateCount) {
      if (window.location.pathname === "/cart") {
        window.location.reload();
      }

      const cartCount = data?.item_count || 0;
      updateCartCount(cartCount);
      return;
    } else {
      toggleCartLoader("hide");
    }
  } catch (err) {
    console.error("Error removing item from cart:", err);
    toggleCartLoader("hide");
  }
}

async function updateCartItemsQuantity(updateObject, successCallback, failCallback, shouldUpdateCount = true) {
  toggleCartLoader("show");
  if (!updateObject) {
    toggleCartLoader("hide");
    return;
  }

  try {
    const data = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        updates: updateObject,
      }),
    });
    if (data.status && data.status !== 200) {
      if (failCallback) failCallback();
      throw new Error(data.description || "Failed to update items in cart");
    } else {
      if (successCallback) successCallback(data);
    }

    if (shouldUpdateCount) {
      if (window.location.pathname === "/cart") {
        window.location.reload();
      }

      const cartCount = data?.item_count || 0;
      updateCartCount(cartCount);
      return;
    } else {
      toggleCartLoader("hide");
    }
  } catch (err) {
    console.error("Error updating cart items:", err);
    toggleCartLoader("hide");
  }
}

async function syncCart(
  cartCookie,
  customerCart,
  guestCart,
  token,
  identityId,
  wasLegacyCartProcessed,
  lid,
  wasPersistentCartProcessed,
) {
  if (cartCookie === customerCart) {
    toggleCartLoader("hide");
    return;
  }
  if (cartCookie && !customerCart) {
    try {
      await fetch(`${window.webAppBase}/persistent-cart`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ cartCookie }),
      });
      let legacyItemsToAdd = [];
      if (!wasLegacyCartProcessed && identityId && token) {
        setCookie("wasLegacyCartProcessed", "true", 365);
        legacyItemsToAdd = (await syncLegacyCartToShopify(identityId, token)) || [];
      }
      if (!lid || wasPersistentCartProcessed) {
        if (legacyItemsToAdd.length > 0) {
          await addCartItems(legacyItemsToAdd);
        } else {
          toggleCartLoader("hide");
          return;
        }
      }
      function onSwymGetInstockCallback(swat) {
        const onSuccess = (list) => {
          const guestCartMap = guestCart.map((item) => item.id);
          const guestCartSet = new Set(guestCartMap);
          const swymItemsToAdd = list?.data?.listcontents
            ? list.data.listcontents.flatMap((item) =>
                guestCartSet.has(item.epi)
                  ? []
                  : [
                      {
                        id: item.epi,
                        quantity: item.qty,
                      },
                    ],
              )
            : [];
          const itemsToAdd = [...legacyItemsToAdd, ...swymItemsToAdd];
          if (itemsToAdd.length > 0) {
            addCartItems(itemsToAdd);
          } else {
            toggleCartLoader("hide");
          }
        };

        let onError = function (error) {
          toggleCartLoader("hide");
          console.error("Error fetching List Contents", error);
        };
        swat.wishlist.fetchPaginatedList({ filterby: "instock", lid, itemslimit: 50 }, onSuccess, onError);
      }
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(onSwymGetInstockCallback);
    } catch (error) {
      toggleCartLoader("hide");
      console.error("Error syncing cart:", error);
    }
  } else {
    setCookie("cart", decodeURIComponent(customerCart), 365, location.hostname);
    if (!guestCart || guestCart.length === 0) {
      try {
        const cartCount = await getItemCount();
        updateCartCount(cartCount);
      } catch (error) {
        console.error("Error syncing cart:", error);
      } finally {
        if (window.location.pathname === "/cart") {
          window.location.reload();
        }
        toggleCartLoader("hide");
      }
    } else {
      try {
        await addCartItems(guestCart);
      } catch (error) {
        toggleCartLoader("hide");
        console.error("Error adding guest cart items:", error);
      }
    }
  }
}

function writeCache(key, data) {
  sessionStorage.setItem(key, JSON.stringify({ createdAt: Date.now(), data }));
}

function readCache(key) {
  const TTL = 5 * 60 * 1000;
  try {
    const cachedSearches = sessionStorage.getItem(key);
    if (!cachedSearches) {
      return null;
    }
    const { createdAt, data } = JSON.parse(cachedSearches);
    if (Date.now() - createdAt > TTL) {
      sessionStorage.removeItem(key);
      return null;
    }
    return data;
  } catch (error) {
    sessionStorage.removeItem(key);
    return null;
  }
}

function invalidateAllSavedSearches() {
  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith("saved-searches")) {
      sessionStorage.removeItem(key);
    }
  });
}

async function fetchSavedSearches(page = 1, { forceRefresh = false } = {}) {
  const key = `saved-searches-page-${page}`;
  const isLoggedIn = window.isLoggedIn || false;
  if (!isLoggedIn) {
    return { data: [] };
  }
  const token = await window.getSessionToken();
  if (!token) {
    return { data: [] };
  }
  const base = window.webAppBase;
  if (!base) {
    return { data: [] };
  }
  if (!forceRefresh) {
    const cached = readCache(key);
    if (cached) {
      return cached;
    }
  }
  try {
    const res = await fetch(`${base}/saved-search?pageSize=50&page=${page}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await res.json();
    writeCache(key, data);
    return data;
  } catch (err) {
    console.error("getSavedSearches", err);
    return { data: [] };
  }
}

/**
 * Detects whether the current browser is iOS (iPhone, iPad, iPod, or iPadOS)
 * or Safari on macOS desktop.
 *
 * This function checks:
 * - `navigator.platform` for iOS device identifiers.
 * - The special case of iPadOS 13+ (which reports as "Mac" in the UA string but supports touch events).
 * - Safari desktop by inspecting the user agent string, while excluding Chromium-based browsers.
 *
 * @function iOSOrSafari
 * @returns {boolean} `true` if the device is iOS/iPadOS or the browser is Safari on macOS desktop, otherwise `false`.
 *
 * @example
 * if (iOSOrSafari()) {
 *   console.log("Running on iOS or Safari desktop");
 * }
 */
function iOSOrSafari() {
  const ua = navigator.userAgent;

  const isIOSDevice = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
    navigator.platform,
  );

  // iPadOS 13+ reports "Mac" but has touch support
  const isIPadOS = ua.includes("Mac") && "ontouchend" in document;

  // Detect Safari desktop (exclude Chrome, Edge, Firefox which also use WebKit base UA parts)
  const isSafariDesktop =
    ua.includes("Safari") && !ua.includes("Chrome") && !ua.includes("Chromium") && !ua.includes("Edg");

  return isIOSDevice || isIPadOS || isSafariDesktop;
}
/**
 * Creates a throttled version of a function that ensures the callback
 * is invoked at most once per animation frame, using the latest arguments.
 *
 * Useful for performance-heavy events like scroll, resize, or mousemove
 * where smooth UI updates are desired.
 *
 * @param {Function} callback - The function to throttle.
 * @returns {Function} A throttled function that syncs execution with requestAnimationFrame.
 */
function smoothThrottle(callback) {
  let isThrottled = false;
  let lastArgs = null;
  let lastContext = null;

  return function (...args) {
    lastArgs = args;
    lastContext = this;

    if (!isThrottled) {
      isThrottled = true;
      requestAnimationFrame(() => {
        callback.apply(lastContext, lastArgs);
        isThrottled = false;
      });
    }
  };
}

function getLoginUrl(baseHref) {
  const base = baseHref || accountLoginUrl;
  const url = new URL(base, window.location.origin);
  url.pathname = url.pathname.replace("/redirect", "/login");
  url.searchParams.set("signinaction", "1");
  const returnTo = decodeURIComponent(getCookie("return_to") || "/");
  if (returnTo) {
    url.searchParams.set("return_to", returnTo);
  }
  return url.toString();
}

function updateLoginLinks() {
  const loginLinks = document.querySelectorAll('a[data-login-link="true"]');
  if (!loginLinks.length) {
    return;
  }
  loginLinks.forEach((link) => {
    const href = link.getAttribute("href");
    if (!href) {
      return;
    }
    if (!href.includes("/login")) {
      return;
    }
    const url = new URL(href, window.location.origin);
    link.href = getLoginUrl(url);
  });
}

function segmentTrack({ eventName, payload } = {}) {
  if (!eventName) {
    console.error("segmentTrack: eventName is required");
    return;
  }

  if (window.analytics && typeof window.analytics.track === "function") {
    try {
      window.analytics.track(eventName, payload);
    } catch (error) {
      console.error(`Error tracking event ${eventName}:`, error);
    }
  } else {
    (window.analytics = window.analytics || []).push(["track", eventName, payload]);
  }
}
